import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { DataType, Legislation } from "../models/lookups";
import { CongressionalDistrict } from "../models/congressional-district";
import { ScorecardView } from "../models/views";
import { appReducer } from "./core.reducer";

export const FEATURE_NAME = 'overview';
export const selectOverview = createFeatureSelector<OverviewState>(FEATURE_NAME);

export const reducers: ActionReducerMap<AppState> = {
  overview: appReducer,
};

export interface OverviewState {
  loading: boolean;
  error: HttpErrorResponse | null;
  states: DataType[];
  legislation: Legislation[];
  voteTypes: DataType[];
  congressmenDisplayNames: DataType[];
  selectedCongressionalDistricts: CongressionalDistrict[];
  parties: DataType[];
  selectedCongressman: DataType | null,
  scorecards: ScorecardView[],
  selectedLocalUnion: number | null
}

export interface AppState {
  overview: OverviewState;
}
